import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../store/store";
import { setPkg } from "../store/reducers/publicSlice";

import { MDXRenderer } from 'gatsby-plugin-mdx';
import { MDXProvider } from "@mdx-js/react";

// import PrivacyPopup from "../components/PrivacyPopup";

import { AnchorLink } from "gatsby-plugin-anchor-links";

import Bubbles from '../components/3dbubbles';

import SEO from '../components/SEO';

import MainMenu from "../components/MainMenu";

type Props = {
    title: string;
    to: string,
};

type IContentPref = {
  className?: any;
  style?: any;
}

const Template = ({location, data}: any) => {
  let dispatch: any = (action: any) => {};

  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const { mdx } = data;
  //const { location } = data;
  const { frontmatter, body, headings, tableOfContents  } = mdx;

  const slugs = require('github-slugger')();

  console.log('data', data);

  if (typeof window !== 'undefined') {
    dispatch = useDispatch<AppDispatch>();
    if (location && location.hash) {
      /*if (location.hash === "#pkg1") {
        dispatch(setPkg(1));
      } else if (location.hash === "#pkg2") {
        dispatch(setPkg(2));
      } else if (location.hash === "#pkg3") {
        dispatch(setPkg(3));
      }*/
    }
  }

  
  const MyH1 = props => {
    //let id = props.id ? slugs.slug(props.id, true) : slugs.slug(props.children.toString());
    //console.log('h1',props);
    return <h1 {...props} />;
    /*return (<React.Fragment>
      <h1 {...props} />
      { frontmatter.keywords ?
        <div className="tags space-x-4">{
          frontmatter.keywords.map((tag: string, key: number) => (
            <React.Fragment key={key}>
              {key > 0 ? <span>|</span> : ""}
              <a href={'#'+slugs.slug(tag)}>{tag}</a>
            </React.Fragment>
          ))
        }</div>
        : ""
      }
      { frontmatter.years ?
        <div className="year">{frontmatter.years.length === 2 ? frontmatter.years.join("–") : frontmatter.years.join(",")}</div>
        : ""
      }
    </React.Fragment>)*/
  };
  
  const MyH2 = props => {
    let string = props.children.toString().replace(/ +$/, '')
    let matched = string.match(/ {#([^]+?)}$/)

    if (matched) {
      let id = matched[1]
      if (!!id.length) {
        if (!props) {
          props = {}
        }

        string = string.substring(0, matched.index);

        props = {...props, id: id, children: string};
      }
    }
    return <h2 {...props} />
  };
  

  const components = {
    wrapper: ({ children, ...props }) => {
      const childrenArray = React.Children.toArray(children);
      let sectionChildren: any[] = [];
      const sections: any[] = [];
      childrenArray.map((child) => {
        if ( child.props.mdxType === "h1" || child.props.mdxType === "h2" ) {
          if (sectionChildren.length > 0) {
            sections.push(sectionChildren);
            sectionChildren = [];
          }
        }
        sectionChildren.push(child);
      })
      if (sectionChildren.length > 0) {
        sections.push(sectionChildren);
      }
      if ( frontmatter.type === "frontpage" ) {
        return <article className="frontpage">{children}</article>;
      }
      return (
        <article className="article">
          {
            sections.map((section: any, key:number) => {
              if (key === 0) {
                let style = {};
                if ( frontmatter.colors && frontmatter.colors.text ) {
                  style = {
                    color: frontmatter.colors.text
                  }
                }
                return (
                  <header key={key} className="header" style={style}>
                    <div className="text-content">{
                      section.map((sec:any, sKey: number) => {
                        return sec;
                      })
                    }</div>
                  </header>
                );
              }
              return (
                <section key={key} className="section">{
                  section.map((sec:any, sKey: number) => sec)
                }</section>
              );
            })
          }
        </article>
      );
    },
    h1: MyH1,
    h2: MyH2,
  }


  let contentPrefs:IContentPref = {
    className: "main-content",
    /*style: {
      backgroundColor: "#019BC1"
    }*/
  }

  if ( frontmatter.type === "frontpage" ) {
    contentPrefs = {
      className: "frontpage",
    }
  }

  if ( frontmatter.colors && frontmatter.colors.bg ) {
    contentPrefs.style = {
      backgroundColor: frontmatter.colors.bg
    }
  }

  /*
  <Box position={[
    Math.round( Math.random() * 280 ) - 140, 
    Math.round( Math.random() * 40 ) - 20, 
    - Math.floor( Math.random() * 150 )
  ]}/>*/
  //    <main {...contentPrefs}>
  let content = (
      <MDXProvider components={components}>
        <div className="fixed z-0 main-content">
          {/*<img className={imageClass} src="/img/kuumailmapallo.jpg" />*/}
          <Bubbles />
        </div>
        <main className="relative z-20 grid">  
            <MDXRenderer headings={headings}>{body}</MDXRenderer>
        </main>
      </MDXProvider>
  );

  if (
      (frontmatter.slug && frontmatter.slug.startsWith("/blog") && frontmatter.slug.length > 6)
      || (frontmatter.type && frontmatter.type === "blog-article")
  ) {
   
  }

  let menuClass = "hidden";
  if (menuOpen === true) {
    menuClass = "h-screen";
  }

  let menuCenter = [];
  let menuRight = [];

    //<AnchorLink to={'/#contact-information'} title={'Ota yhteyttä'} />

  if (frontmatter.type) {
    if (frontmatter.type === "landing-page") {
      menuCenter = [];
      menuRight = [];
      //contentPrefs.className = "article";
    } else if (frontmatter.type === "landing-fullpages") {
      menuCenter = [];
      menuRight = [];
    } else if (frontmatter.type === "default-page") {
      //contentPrefs.className = "article";
    }
  }


  if ( frontmatter.lang && frontmatter.lang === "en" ) {
    menuCenter = [];
    menuRight = [];
  }

  return (
    <React.Fragment>
      <SEO page={frontmatter} />
      <header className="page-header">
        <div className="md:hidden absolute text-3xl cursor-pointer text-normal" onClick={() => setMenuOpen(!menuOpen)}>
            { menuOpen === true ? "x" : "=" }
        </div>
        <nav className="nav">
          <div className="flex-auto md:flex-initial text-center py-2 font-serif">
            <AnchorLink to={'/'} title="Lemonade Farm" className="inline-block">
              <img src="/img/lemonade-farm-icon.svg" className="w-5 mr-2 inline-block" alt="Lemonade Farm" />
              Lemonade Farm
            </AnchorLink>
          </div>
          <div className="wide-nav pt-2">
            {menuCenter.map((item, key: number) => <React.Fragment key={key}>{item}</React.Fragment>)}
          </div>
          <div className="hidden md:block text-right pt-2" /* md:w-24 */>
            {menuRight.map((item, key: number) => <React.Fragment key={key}>{item}</React.Fragment>)}
          </div>
        </nav>
        <MainMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      </header>
      {content}
      {/*<footer className="page-footer flex w-full bg-primary-100 mt-20 bg-opacity-50">
        
            </footer>*/}
    </React.Fragment>
  );
}

export default Template;
